"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossSectionsModePage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const infobox_1 = require("@completeanatomy/infobox");
const RegionModeTemplate_1 = require("../../templates/RegionModeTemplate");
const bridge_1 = require("@completeanatomy/bridge");
const i18n_1 = require("@completeanatomy/i18n");
const device_1 = require("@completeanatomy/device");
const models_1 = require("@completeanatomy/models");
function CrossSectionsModePage() {
    const selectedPart = (0, models_1.useSelectedPart)();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoizedSelectedPart = (0, react_1.useMemo)(() => selectedPart, []);
    const { isMobile } = (0, device_1.usePlatform)();
    const bridge = (0, bridge_1.useBridge)();
    const onBack = () => {
        bridge === null || bridge === void 0 ? void 0 : bridge.exitCrossSectionsMode();
    };
    const disabledButtons = [
        //   MenuButtonType.Search,
        //   MenuButtonType.Library,
        //   MenuButtonType.Store,
        //   MenuButtonType.Settings,
        'BodyRegionsButton',
    ];
    if (isMobile) {
        return ((0, jsx_runtime_1.jsx)(infobox_1.InfoBoxModeTemplate, { mode: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.mode, {
                mode: i18n_1.Strings.infoBox.tabs['cross-sections'],
            }), title: memoizedSelectedPart.name, onBack: onBack, disableHideUI: true, detail: (0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: !!selectedPart.identifier &&
                    selectedPart.identifier !== memoizedSelectedPart.identifier, timeout: 300, mountOnEnter: true, unmountOnExit: true, children: (0, jsx_runtime_1.jsx)(SelectedPartContainer, { children: selectedPart.name }) }), children: (0, jsx_runtime_1.jsx)(infobox_1.CrossSectionsCarousel, {}) }));
    }
    return ((0, jsx_runtime_1.jsx)(RegionModeTemplate_1.RegionModeTemplate, { mode: (0, i18n_1.Localized)(i18n_1.Strings.infoBox.mode, {
            mode: i18n_1.Strings.infoBox.tabs['cross-sections'],
        }), region: memoizedSelectedPart === null || memoizedSelectedPart === void 0 ? void 0 : memoizedSelectedPart.name, left: (0, jsx_runtime_1.jsx)(StyledInfoBoxCrossSectionsTab, {}), onBack: onBack, showHistory: false, disabledButtons: disabledButtons, resetModel: false }));
}
exports.CrossSectionsModePage = CrossSectionsModePage;
const StyledInfoBoxCrossSectionsTab = (0, styled_components_1.default)(infobox_1.CrossSectionsTab) `
  max-width: ${({ theme }) => theme.infoBoxWidth}px;
  height: 100%;
  max-height: ${({ theme }) => `calc(100% - ${theme.headerHeight}px - ${theme.footerHeight}px)`};

  padding-left: 8px;
`;
const SelectedPartContainer = styled_components_1.default.div `
  width: 100%;
  height: 45px;

  color: ${({ theme }) => theme.whiteSecondary};
  font-size: 16px;
  line-height: 45px;
  text-align: center;

  background-color: ${({ theme }) => theme.radiology.topBar.background};

  transition: transform 300ms ease-out;

  pointer-events: none;

  &.enter {
    transform: translateY(100%);
  }

  &.enter-active,
  &.enter-done {
    transform: translateY(0);
  }

  &.exit-active,
  &.exit-done {
    transform: translateY(100%);
  }
`;
